import { createBrowserRouter } from 'react-router-dom';
import { Login } from '@/modules/auth/pages/Login';
import { Register } from '@/modules/auth/pages/Register';
import { MainLayout } from '@/shared/components/layout/MainLayout';
import { ProtectedRoute } from '@/shared/components/layout/ProtectedRoute';
import { DashboardPage } from '@/modules/dashboard/pages/DashboardPage';
import { CompaniesPage } from '@/modules/companies/pages/CompaniesPage';
import { UsersPage } from '@/modules/users/pages/UsersPage';
import { PlansPage } from '@/modules/plans/pages/PlansPage';
import { SettingsPage } from '@/modules/settings/pages/SettingsPage';
import { IntegrationsPage } from '@/modules/integrations/pages/IntegrationsPage';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/register',
    element: <Register />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'companies', element: <CompaniesPage /> },
      { path: 'users', element: <UsersPage /> },
      { path: 'plans', element: <PlansPage /> },
      { path: 'integrations', element: <IntegrationsPage /> },
      { path: 'settings', element: <SettingsPage /> },
    ],
  },
]);
